import { useFormContext } from 'react-hook-form';
import { usersAdvanceFilterQuery } from 'wisestep-api';
import { WsAutocompleteInput } from 'wisestep-base';

import {
  getRecruiterNameAndEmail,
  transformIRecruiterTeamNameOptionsToStringArray,
} from '../../../features/jobs/helper';
interface RecruiterAutoCompleteSuggestionsProps {
  name: string;
  multiple?: boolean;
  placeholder?: string;
  focused?: boolean;
  getRecruiterName?: boolean;
}
const REGEX_TO_GET_TEXT_IN_PARENTHESIS = /\((.*?)\)/;

const RecruiterAutoCompleteSuggestions = ({
  name,
  multiple,
  placeholder = 'Eg, Michael',
  focused = false,
  getRecruiterName = false,
}: RecruiterAutoCompleteSuggestionsProps) => {
  const { setValue } = useFormContext();

  const onRecruiterInputKey = async (accountManagerPrefix: string) => {
    const response = await usersAdvanceFilterQuery(accountManagerPrefix);
    const result = getRecruiterNameAndEmail(response.data);
    return transformIRecruiterTeamNameOptionsToStringArray(result);
  };

  const onChange = (data) => {
    if (multiple)
      setValue(
        name,
        data.map((item) => item.match(REGEX_TO_GET_TEXT_IN_PARENTHESIS)[0].slice(1, -1))
      );
    else {
      getRecruiterName
        ? setValue(name, data.replace(REGEX_TO_GET_TEXT_IN_PARENTHESIS, '').trim())
        : setValue(name, data.match(REGEX_TO_GET_TEXT_IN_PARENTHESIS)[0].slice(1, -1));
    }
  };
  return (
    <WsAutocompleteInput
      getOptions={onRecruiterInputKey}
      onChange={onChange}
      options={[]}
      placeholder={placeholder}
      multiple={multiple}
      freeSolo={false}
      name="recruiterFilterValues"
      size="small"
      focused={focused}
    />
  );
};
export default RecruiterAutoCompleteSuggestions;
